import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonService } from '@common/services/common.service';
import { EncryptionProviderService } from '@common/services/encryption.service';
import { isLoadIgnore} from '@common/constants/load-ignore.constant';
import { CORE_PROPS } from 'src/core/core.properties';
import { CoreService } from 'src/core/core.service';
import { PlatformDetails } from '../models/platform-details';
import { AlertController } from '@ionic/angular';
declare var window: any;
@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  deviceDetails: any = {};
  platformDetails: PlatformDetails;

  constructor(
    private router: Router,
    private commonService:CommonService,
    private encryptionProviderService: EncryptionProviderService,
    private _core_props: CORE_PROPS,   public _core_srv: CoreService,private alertController:AlertController) {
      this.encryptionProviderService = encryptionProviderService;
    }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if(!isLoadIgnore(request.url)){
      CommonService.requestTracker.push(request.url);
      CommonService.showLoader();
    }


    return next.handle(request).pipe(
      tap(
        (event) => {
          if (event instanceof HttpResponse) {
            const resp = event;
            if(resp.body['eData']){
               const decryptRes = JSON.parse(this.encryptionProviderService.decryptData(
                resp.body['eData']
              ));
              this.handleSessionError(decryptRes.error);
            }else{
              this.handleSessionError(resp.body.error);
            }
            this.hideLoader();
          }
        },
        (error) => {
          this.handleSessionError();
          this.hideLoader();
        }
      )
    );
  }

  private hideLoader(){
    CommonService.requestTracker.pop();
    if(!CommonService.requestTracker.length){
      CommonService.hideLoader();
    }
  }

  private handleSessionError(error?: any) {
    if (error && (error.errorCode === -114 || error.errorCode === -112)) {
      sessionStorage.removeItem('session-token');
      if(this.commonService.getPlatformDetails().isAndroidApp){
        this.router.navigate(['/login'], {queryParams: {'session-error':true}})
      }else{
        this.router.navigate(['/login'], {queryParams: {'session-error':true}}).then(() => {
          window.location.reload();
      });
      }
    }
  }

  getPlatformDeviceDetails(){
    this._core_props.getCorePlatformDetails().subscribe(res => {
      if (res !== null && res != undefined) {
        this.platformDetails = res;
        
      }
    });

      this._core_props.getDeviceDetails().subscribe(res => {
        if (res !== null && res != undefined) {
          this.deviceDetails = res;
        }
      });
  }
 
}

